module.exports = __webpack_public_path__ + "img/chiku06.84e69ed5.png";